/**
 * Model for a Voyage Bulk
 */
var VRC = VRC || {};

VRC.VoyageBulk = (function (voyageBulk) {

	var _cargoItemId;
	var _containerId;
	var _voyageBulkId;
	var _bulkTankId;
	var _bulkTypeName;
	var _bulkTypeId;
	var _itemDescription;
	var _valueQty;
	var _valueType;
	var _qtyRob;
	var _sg;
	var _dgInfo;
	var _remarks;
	var _action;
	var _date;
	var _companyId;
	var _companyName;
	var _originId;
	var _originName;
	var _destinationId;
	var _destinationName;
	var _tankColour;
	var _itemGroupName;
	var _itemGroupId;
	var _itemId;
	var _displayPort;
	var _actionObject;
	var _cleanTypeName;

	var init = function (voyageBulk) {
		voyageBulk = voyageBulk || {};
		parse(voyageBulk);
	};

	var getNewId = function () {
		var now = moment();
		return 'bulk_' + Math.floor(Math.random() * 1000) + '_' + now.valueOf();
	};

	var getItemId = function () {
		return _itemId;
	};

	var setItemId = function (itemId) {
		itemId = VRC.Utils.Number.parseInt(itemId);
		_itemId = itemId;
	};

	var getVoyageBulkId = function () {
		return _voyageBulkId;
	};

	var setVoyageBulkId = function (voyageBulkId) {
		_voyageBulkId = voyageBulkId;
	};

	var getBulkTankId = function () {
		return _bulkTankId;
	};

	var setBulkTankId = function (bulkTankId) {
		bulkTankId = VRC.Utils.Number.parseInt(bulkTankId);
		_bulkTankId = bulkTankId;
	};

	var getBulkTypeId = function () {
		return _bulkTypeId;
	};

	var setBulkTypeId = function (bulkTypeId) {
		bulkTypeId = VRC.Utils.Number.parseInt(bulkTypeId);
		_bulkTypeId = bulkTypeId;

		setBulkTypeName();
	};

	var getItemDescription = function () {
		return _itemDescription;
	};

	var setItemDescription = function (definition) {
		_itemDescription = definition;
	};

	var getValueQty = function () {

		return _valueQty;
	};

	var setValueQty = function (qty) {

		qty = VRC.Utils.Number.parseFloat(qty);
		_valueQty = qty;
	};

	var getQtyRob = function () {
		return _qtyRob;
	};

	var setQtyRob = function (qtyRob) {

		qtyRob = VRC.Utils.Number.parseFloat(qtyRob);

		_qtyRob = qtyRob
	};

	var getValueUnit = function () {
		return _valueType;
	};

	var setValueUnit = function (unit) {
		_valueType = unit;
	};

	var getSg = function () {

		return _sg;
	};

	var setSg = function (sg) {
		sg = VRC.Utils.Number.parseFloat(sg);

		_sg = sg;
	};

	var getDgInfo = function () {
		return _dgInfo;
	};

	var setDgInfo = function (dangerous) {
		_dgInfo = dangerous;
	};

	var getRemarks = function () {
		return _remarks;
	};

	var setRemarks = function (remarks) {

		_remarks = remarks;
	};

	var getAction = function () {
		return _action;
	};

	var setAction = function (action) {
		_action = action;
	};

	var getDate = function () {
		return _date;
	};

	var setDate = function (date) {
		//We are forgiving with the format in.
		if (moment(date, g_timeStampFormat, true).isValid()) {

			_date = moment(date, g_timeStampFormat).format(g_timeStampFormat);

		}
		else {
			_date = moment(date).format(g_timeStampFormat);
		}
	};

	var getDisplayPort = function () {
		return _displayPort;
	};

	var setDisplayPort = function (displayPort) {
		if (isTankClean()) {
			displayPort = "Cleaned Tank";
		}

		if (!displayPort) {
			displayPort = VRC.MasterDataService.getDisplayPort(getDestinationId(), getOriginId());
		}
		_displayPort = displayPort;
	};

	var getCompanyId = function () {

		return _companyId;
	};

	var setCompanyId = function (company) {
		company = VRC.Utils.Number.parseInt(company);
		_companyId = company;
		setCompanyName();
	};
	var getCompanyName = function () {
		return _companyName;
	};

	var setCompanyName = function (companyName) {
		if (!companyName) {
			var company = VRC.MasterDataService.getCompany(getCompanyId());
			if (company) {
				companyName = company.name;
			}
		}
		_companyName = companyName;
	};

	var getBulkTypeName = function () {
		return _bulkTypeName;
	};

	var setBulkTypeName = function (bulkTypeName) {
		if (!bulkTypeName) {
			var bulkType = VRC.MasterDataService.getBulkType(getBulkTypeId());
			if (bulkType) {
				bulkTypeName = bulkType.name;
			}
		}
		_bulkTypeName = bulkTypeName;
	};

	var getOriginId = function () {
		return _originId;
	};

	var setOriginId = function (origin) {
		_originId = VRC.Utils.Number.parseInt(origin);
		if(_originId) {
			setOriginName();
		} else if (isNaN(_originId) && origin) {
			//If the origin has chars in it save it as a string. (Probably a vessel)
			_originId = origin;
			setOriginName();
		}

	};

	var getOriginName = function () {
		return _originName;
	};

	var setOriginName = function (originName) {

		if (!originName) {
			var originId = getOriginId();
			if (isNaN(VRC.Utils.Number.parseInt(originId))) {
				// Set the origin as a vessel ID prefixed with 'vessel-'
				var origin = VRC.MasterDataService.getVessel(originId);
				if (origin) {
					originName = origin.name;
				}
			} else {
				var origin = VRC.MasterDataService.getPort(originId);
				if (origin) {
					originName = origin.name;
				}
			}
		}
		_originName = originName;
	};

	var getDestinationId = function () {
		return _destinationId;
	};

	var setDestinationId = function (destination) {
		destination = VRC.Utils.Number.parseInt(destination);
		_destinationId = destination;
		setDestinationName();
	};

	var getDestinationName = function () {
		return _destinationName;
	};

	var setDestinationName = function (destinationName) {
		if (!destinationName) {
			var destination = VRC.MasterDataService.getPort(getDestinationId());
			if (destination) {
				destinationName = destination.name;
			}
		}
		_destinationName = destinationName;
	};

	var getTankColour = function () {
		return _tankColour;
	};

	var setTankColour = function (tankColour) {
		// #54169 added a check for "Cleaned" in the remarks, needed in new voyages as the tank cleaning is not carried over.
		var remarks = getRemarks();
		if (isTankClean() || (remarks && remarks.indexOf('Cleaned ') > -1)) {
			tankColour = "#ffffff";
		}

		if (!tankColour) {
			tankColour = VRC.MasterDataService.getColour(getDestinationId(), getOriginId());
		}
		_tankColour = tankColour;
	};

	var getCargoItemId = function () {

		return _cargoItemId;
	};

	var setCargoItemId = function (cargoId) {
		cargoId = VRC.Utils.Number.parseInt(cargoId);
		_cargoItemId = cargoId;
	};

	var getContainerId = function () {
		return _containerId;
	};

	var setContainerId = function (containerId) {
		containerId = VRC.Utils.Number.parseInt(containerId);
		_containerId = containerId;
	};

	var getBulkTank = function () {
		var bulkTankID = getBulkTankId();
		return VRC.BulkTankManager.getBulkTankById(bulkTankID);
	};

	var getItemGroupName = function () {
		return _itemGroupName;
	};

	var setItemGroupName = function (itemGroupName) {
		_itemGroupName = itemGroupName;
	};

	var isLoadAction = function () {
		return getAction() === g_actions.load || getAction() === g_actions.transferFrom;
	};

	var isStartRobAction = function () {
		return getAction() === g_actions.start_rob;
	};

	var isOffloadAction = function () {
		return getAction() === g_actions.offload;
	};

	var isRob = function () {
		return getAction() === g_actions.rob;
	};

	var isRobAdjustment = function () {

		return getAction() === g_actions.rob_adjustment;
	};

	var isCalcAction = function () {
		var calcActions = [g_actions.load, g_actions.offload, g_actions.discharge, g_actions.deviation, g_actions.tankCleanStarted, g_actions.tankClean, g_actions.start_rob, g_actions.dump, g_actions.transferFrom, g_actions.transferTo];
		return calcActions.indexOf(getAction()) !== -1;
	};

	var isTankCleanStarted = function () {
		return getAction() === g_actions.tankCleanStarted;
	};

	var isTankClean = function () {
		return getAction() === g_actions.tankClean;
	};

	var createNewId = function () {
		setVoyageBulkId(getNewId())
	};

	var getItemGroupId = function () {
		return _itemGroupId;
	};

	var setItemGroupId = function (itemGroupId) {
		_itemGroupId = itemGroupId;
	};

	var getActionObject = function () {
		return _actionObject;
	};

	var setActionObject = function (actionObject) {
		_actionObject = actionObject;
	};

	var setCleanTypeName = function () {
		var cleanType = VRC.MasterDataService.getBulkCleanType(getActionObject());
		if (cleanType && getAction() === "tank_clean") {
			_cleanTypeName = cleanType.name;
		}
	};

	var getCleanTypeName = function () {
		return _cleanTypeName;
	};

	var getCalcQty = function () {
		if (isLoadAction() || isStartRobAction()) {
			return getValueQty();
		}
		else {
			return getValueQty() * -1;
		}
	};

	var getCalcId = function () {
		var id = getVoyageBulkId();
		if (typeof id === 'string') {
			var prefix = 'bulk_';
			var isAdhoc = id.slice(0, prefix.length) === prefix;
			if (isAdhoc) {
				var index = id.indexOf('_', 5) + 1;
				id = parseInt(id.slice(index));
			}
		}
		else {
			id = id * -1;
		}

		return parseInt(id);

	};

	var update = function (json) {

		parse($.extend(toJson(), json));

	};

	var parse = function (voyageBulk) {
		if (voyageBulk.voyageBulkId) {
			setVoyageBulkId(voyageBulk.voyageBulkId);
		}
		else {
			createNewId();
		}

		setBulkTankId(voyageBulk.bulkTankId);
		setBulkTypeId(voyageBulk.bulkTypeId);
		setItemDescription(voyageBulk.itemDescription);
		setItemGroupName(voyageBulk.itemGroupName);
		setItemId(voyageBulk.itemId);
		setValueQty(voyageBulk.valueQty);
		setQtyRob(voyageBulk.qtyRob);
		setValueUnit(voyageBulk.valueUnit);
		setSg(voyageBulk.sg);
		setDgInfo(voyageBulk.dgInfo);
		setRemarks(voyageBulk.remarks);
		setAction(voyageBulk.action);
		setDate(voyageBulk.date);
		setCompanyId(voyageBulk.companyId);
		setOriginId(voyageBulk.originId);
		setDestinationId(voyageBulk.destinationId);
		setTankColour(voyageBulk.tankColor);
		setCargoItemId(voyageBulk.cargoItemId);
		setDisplayPort();
		setContainerId(voyageBulk.containerId);
		setItemGroupId(voyageBulk.itemGroupId);
		setActionObject(voyageBulk.actionObject);
		setCleanTypeName();
	};

	var parseFromBulkRequest = function (bulkRequest, tank, qty, qtyRob, date, remarks, type) {

		setRemarks(remarks);
		setAction(g_actions.load);
		setDate(date);
		setValueQty(qty);
		setQtyRob(qtyRob);
		setValueUnit(type);
		setBulkTankId(tank ? tank.getBulkTankId() : undefined);
		setBulkTypeId(bulkRequest.getBulkTypeId());
		setItemDescription(bulkRequest.getItemDescription());
		setSg(bulkRequest.getSg());
		setDgInfo(bulkRequest.getDangerous());
		setCompanyId(bulkRequest.getCompanyId());
		setOriginId(bulkRequest.getOriginId());
		setDestinationId(bulkRequest.getDestinationId());
		setTankColour(bulkRequest.getPortColourCode());
		setCargoItemId(bulkRequest.getCargoItemId());
		setContainerId(bulkRequest.getContainerId());
		setItemGroupName(bulkRequest.getItemGroupName());
		setItemGroupId(bulkRequest.getItemGroupId());
		setItemId(bulkRequest.getItemId());
		setDisplayPort(bulkRequest.getDisplayPort());
		setActionObject(voyageBulk.actionObject);
		setCleanTypeName();
	};

	var toJson = function () {
		return {
			voyageBulkId: getVoyageBulkId(),
			bulkTankId: getBulkTankId(),
			bulkTypeId: getBulkTypeId(),
			bulkTypeName: getBulkTypeName(),
			itemDescription: getItemDescription(),
			valueQty: getValueQty(),
			qtyRob: getQtyRob(),
			valueUnit: getValueUnit(),
			sg: getSg(),
			dgInfo: getDgInfo(),
			remarks: getRemarks(),
			action: getAction(),
			date: getDate(),
			companyId: getCompanyId(),
			companyName: getCompanyName(),
			originId: getOriginId(),
			originName: getOriginName(),
			destinationId: getDestinationId(),
			destinationName: getDestinationName(),
			tankColor: getTankColour(),
			cargoItemId: getCargoItemId(),
			containerId: getContainerId(),
			itemGroupName: getItemGroupName(),
			itemGroupId: getItemGroupId(),
			itemId: getItemId(),
			displayPort: getDisplayPort(),
			actionObject: getActionObject(),
			cleanTypeName: getCleanTypeName()
		}
	};

	init(voyageBulk);

	return {
		getAction: getAction,
		setAction: setAction,
		getBulkTankId: getBulkTankId,
		setBulkTankId: setBulkTankId,
		getCompany: getCompanyId,
		setCompany: setCompanyId,
		getContainerId: getContainerId,
		setContainerId: setContainerId,
		getDangerous: getDgInfo,
		setDangerous: setDgInfo,
		getDate: getDate,
		setDate: setDate,
		getItemDescription: getItemDescription,
		setItemDescription: setItemDescription,
		getDestinationId: getDestinationId,
		setDestinationId: setDestinationId,
		getDestinationName: getDestinationName,
		setDestinationName: setDestinationName,
		getVoyageBulkId: getVoyageBulkId,
		setVoyageBulkId: setVoyageBulkId,
		getValueQty: getValueQty,
		setValueQty: setValueQty,
		getQtyRob: getQtyRob,
		setQtyRob: setQtyRob,
		getRemarks: getRemarks,
		setRemarks: setRemarks,
		getOriginId: getOriginId,
		setOriginId: setOriginId,
		getOriginName: getOriginName,
		setOriginName: setOriginName,
		getSg: getSg,
		setSg: setSg,
		getBulkTypeId: getBulkTypeId,
		setBulkTypeId: setBulkTypeId,
		setBulkTypeName: setBulkTypeName,
		getValueUnit: getValueUnit,
		setValueUnit: setValueUnit,
		getCargoItemId: getCargoItemId,
		setCargoItemId: setCargoItemId,
		getItemGroupName: getItemGroupName,
		setItemGroupName: setItemGroupName,
		getItemGroupId: getItemGroupId,
		setItemGroupId: setItemGroupId,
		toJson: toJson,
		parse: parse,
		isLoadAction: isLoadAction,
		isOffloadAction: isOffloadAction,
		isTankClean: isTankClean,
		isTankCleanStarted: isTankCleanStarted,
		parseFromBulkRequest: parseFromBulkRequest,
		isCalcAction: isCalcAction,
		createNewId: createNewId,
		isRob: isRob,
		isStartRobAction: isStartRobAction,
		getTankColour: getTankColour,
		setTankColour: setTankColour,
		getDisplayPort: getDisplayPort,
		setDisplayPort: setDisplayPort,
		getCalcQty: getCalcQty,
		update: update,
		getCalcId: getCalcId,
		isRobAdjustment: isRobAdjustment,
		getactionObject: getActionObject,
		setactionObject: setActionObject,
		getCleanTypeName: getCleanTypeName
	}
});
